import { defineMessages } from 'react-intl';

export default defineMessages({

    buildingCodeClass: {
        id: 'tfpa.policyChange.ho.views.construction.Building Code Class',
        defaultMessage: 'Building Code Class'
    },
    buildingCode: {
        id: 'tfpa.policyChange.ho.views.construction.Building Code',
        defaultMessage: 'Building Code'
    },
    addedLivingSpConDate: {
        id: 'tfpa.policyChange.ho.views.construction.Added Living Space Construction Date',
        defaultMessage : 'Added Living Space Construction Date'
    },
    orgConstructionDate: {
        id: 'tfpa.policyChange.ho.views.construction.Original Construction Date',
        defaultMessage : 'Original Construction Date'
    },
    yearMustmatch: {
        id: 'tfpa.policyChange.ho.views.construction.Year must match Year Built.',
        defaultMessage : 'Year must match Year Built.'
    },
    cannotBeFutureDate: {
        id: 'tfpa.policyChange.ho.views.construction.Date cannot be in the future.',
        defaultMessage : 'Date cannot be in the future.'
    },
    dateAlert: {
        id : 'tfpa.policyChange.ho.views.construction.Alert',
        defaultMessage: 'Alert'
    },
    complianceCertificate: {
        id: 'tfpa.policyChange.ho.views.construction.Certificate of Compliance or an Official Building Statement?',
        defaultMessage: 'Certificate of Compliance or an Official Building Statement?'
    }

})